import React from 'react';
import { MyProfile, PrivacyPage, TermsPage } from './pages';
import { Navigate, Route, Routes } from 'react-router-dom';
import { APP_HUBS_BASE } from '@src/core/routes';

const HUB_UPDATE = `${APP_HUBS_BASE}/update-hub`;

const ProfileFeature: React.FC = () => {
  return (
    <Routes>
      <Route index element={<MyProfile />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="update-hub" element={<Navigate to={HUB_UPDATE} replace />} />
    </Routes>
  );
};

export default ProfileFeature;
